import React from 'react'
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import DoubleButton from '../components/DoubleButton';

function Confirm(
    {
        open,
        confirmTitle,
        confirmText,
        confirmText2,
        onConfirm,
        onCancel,
        labelConfirm = "yes",
        labelCancel = "no",
        translateConfirmTexts = true
    }) {

    return (
        <Dialog
            title={!!confirmTitle ? Tr(confirmTitle) : Tr('attention')}
            open={open}
            titleCentered
            onClose={onCancel}
            dialogActions={<DoubleButton
                justify='flex-end'
                labelFirst={Tr(labelCancel)}
                labelSecond={Tr(labelConfirm)}
                onClickFirst={onCancel}
                onClickSecond={onConfirm}
            />}
        >
            {!!confirmText && <Typography variant='body1'>
                {translateConfirmTexts ? Tr(confirmText) : confirmText}
            </Typography>}
            {!!confirmText2 && <Typography variant='body1'>
                {translateConfirmTexts ? Tr(confirmText2) : confirmText2}
            </Typography>}

        </Dialog>
    )
}

Confirm.propTypes = {
    open: PropTypes.bool.isRequired,
    confirmText: PropTypes.string.isRequired,
    confirmText2: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    labelConfirm: PropTypes.string,
    labelCancel: PropTypes.string,
    translateConfirmTexts: PropTypes.bool
}

export default Confirm;